// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__Xw8uA","container":"Layout_container__SrF+a"};